const WorkExperience = [
   
  
    {
        id: 1,
        title: "Frontend Developer,Remote",
        company: "Austech-Ic",
        yearsActive: "(April 10 2022, - December 2024)",
        information: [
            "At Austech-Ic, I began as a frontend developer intern and was promoted to a full-time frontend developer role. During my time with the company, I contributed to the development of several major projects, including a Property Management System built with Next.js, a Content Management System using React.js, and the web version of an Integrated Health and Wellness Platform that supports both physical and mental health. I collaborated closely with UI/UX designers to implement intuitive user interfaces based on wireframes and prototypes, while integrating REST APIs to ensure seamless interaction between frontend and backend services. I also gained hands-on experience with responsive design and mobile-first development practices, consistently working to meet and exceed client expectations.",
        ],
        
    },
    {
        id: 2,
        title: "Frontend Developer,Remote",
        company: "Vant Inc (Fintech)",
        yearsActive: "(January 2025, - Present)",
        information: [
            "At Vant Inc, where I play an active role in building and maintaining web applications. One of my key contributions has been to the Vant for Business Admin Dashboard, a robust platform designed to streamline business operations and alos building the vantapp website from the scratch. I use React.js, Next.js, and Tailwind CSS and other frontend technologies to build responsive, accessible, and user-friendly interfaces, following mobile-first design principles and ensuring cross-browser compatibility. My responsibilities include integrating RESTful APIs in collaboration with backend engineers, optimizing data flow, and continuously improving the user experience through testing and feedback. I regularly participate in code reviews and team knowledge-sharing sessions to contribute to a high-performing, collaborative development environment.",
           
        ],
    },
    
    
];

export default WorkExperience;
